import { Box, Heading, HeadingProps, HStack } from '@chakra-ui/layout';
import { StyleProps } from '@chakra-ui/styled-system';
import { useMultiStyleConfig } from '@chakra-ui/system';
import React from 'react';

export enum HeadlineDividerVariant {
  short = 'short',
  light = 'light',
  lightShort = 'lightShort',
}

interface HeadlineDividerProps extends StyleProps {
  as?: HeadingProps['as'];
  variant?: HeadlineDividerVariant;
}

const HeadlineDivider: React.FC<HeadlineDividerProps> = ({
  as,
  children,
  variant,
  ...rest
}) => {
  const styles = useMultiStyleConfig('HeadlineDivider', { variant });

  return (
    <Box __css={styles.container} {...rest}>
      <HStack spacing={0}>
        <Box __css={styles.divider}></Box>
        <Heading as={as} sx={styles.text}>
          {children}
        </Heading>
      </HStack>
    </Box>
  );
};

export default HeadlineDivider;
